import { queryOptions, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { responseScheme } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

export const isPasswordSetQueryOptions = queryOptions({
  queryKey: ['/IsSetPassWord'],
  queryFn: ({ signal }) =>
    fetcher<IsPasswordSetResponse>('/IsSetPassWord', undefined, {
      signal,
      schema: isPasswordSetResponseSchema,
      validResponseCodes: [0],
    }).then((res) => res.IsSetPwd === 1),
  staleTime: 0,
  gcTime: 0,
});

export default function useIsPasswordSet() {
  return useQuery(isPasswordSetQueryOptions);
}

const isPasswordSetResponseSchema = responseScheme.extend({
  IsSetPwd: z.union([z.literal(0), z.literal(1)]),
});

type IsPasswordSetResponse = z.infer<typeof isPasswordSetResponseSchema>;
